module.exports = __webpack_public_path__ + "static/media/sort-asc.2f9bff7a.svg";